import { useAsyncData } from '#imports'
import type { Ref } from 'vue'

import type { AlgoliaProduct } from '@backmarket/http-api/src/api-specs-search-reco/search/searchAlgolia'
import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'

// Fetches a single Algolia outlet product by objectID via the Nuxt server
// route, which proxies the search to avoid CORS restrictions on the BM search
// proxy when the client navigates SPA (no SSR for that page).
export function useOutletProduct(objectId: Ref<string>) {
  return useAsyncData<AlgoliaProduct | null>(
    getAsyncDataKey('outlet-product', { objectId: objectId.value }),
    () =>
      $fetch<AlgoliaProduct | null>(
        `/front-office/outlet/product/${objectId.value}`,
      ),
    {
      watch: [objectId],
      default: () => null,
    },
  )
}
